import type { ReferentialsResponseDto } from '@/api/WhisApi/generated/model/referentialsResponseDto';
import AsyncStorage from '@react-native-async-storage/async-storage';

const REFERENTIALS_STORAGE_KEY = 'referentials_cache_v1';

export const getStoredReferentials =
  async (): Promise<ReferentialsResponseDto | null> => {
    try {
      const value = await AsyncStorage.getItem(REFERENTIALS_STORAGE_KEY);
      if (!value) {
        return null;
      }

      return JSON.parse(value) as ReferentialsResponseDto;
    } catch (error) {
      console.error(
        '[REFERENTIALS_STORAGE] Failed to read referentials cache:',
        error,
      );
      return null;
    }
  };

export const hasStoredReferentials = async (): Promise<boolean> => {
  const referentials = await getStoredReferentials();
  return Boolean(referentials);
};

export const saveStoredReferentials = async (
  referentials: ReferentialsResponseDto,
): Promise<void> => {
  try {
    await AsyncStorage.setItem(
      REFERENTIALS_STORAGE_KEY,
      JSON.stringify(referentials),
    );
  } catch (error) {
    console.error(
      '[REFERENTIALS_STORAGE] Failed to persist referentials cache:',
      error,
    );
  }
};
